export const IlluDigitaleVerwaltungssysteme = () => {
  return (
    <svg
      //width="152.6841mm"
      //height="107.42851mm"
      version="1.1"
      viewBox="0 0 12182.705 9616.703"
      id="svg39"
      className="navimages"
    >
      <defs id="defs4"></defs>
      <g id="Ebene_x0020_1" transform="translate(-4478.7307,-10012.297)">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_1028950736">
          <path
            className="fil0"
            d="m 6039,11873 c -41,37 -163,96 -220,118 -193,72 -482,304 -451,582 30,264 169,275 348,344 83,32 159,57 259,81 88,20 213,44 229,123 18,85 -96,160 -154,185 -150,65 -136,75 -179,164 -35,73 -87,116 -13,264 46,94 102,112 228,117 244,10 633,-157 892,18 52,35 150,146 181,160 -187,14 -259,32 -402,129 -12,7 -19,12 -27,26 l -9,27 c -13,28 -91,70 -132,101 -172,130 -293,264 -461,391 l -491,360 c -41,29 -88,58 -126,89 -46,37 -77,61 -123,92 -60,41 -197,170 -245,193 11,-118 80,-342 95,-480 6,-56 29,-127 -30,-143 -42,29 -40,124 -51,182 l -128,586 c 74,2 70,-8 143,-78 87,-83 142,-130 245,-203 l 386,-286 c 212,-153 365,-262 567,-437 23,-19 37,-40 59,-58 113,-98 397,-347 527,-368 90,-14 139,5 213,4 l 56,-86 c 184,89 604,37 789,-72 21,-13 66,-47 85,-51 -21,63 -46,132 -40,212 46,-49 70,-158 83,-228 9,-48 9,-38 44,-66 25,-21 33,-29 54,-53 44,-51 98,-93 122,-202 52,-245 -89,-387 82,-732 93,-188 264,-326 252,-601 -3,-54 1,-18 19,-73 9,-30 6,-63 20,-86 8,-12 25,-10 32,-76 22,-227 -247,-481 -418,-539 -377,-128 -442,-45 -698,15 -155,36 -245,-6 -367,-33 -266,-59 -773,-76 -1027,66 -146,82 -217,139 -218,322 z"
            id="path1"
          />
          <path
            className="fil0"
            d="m 12181,11256 c -31,-30 -22,-62 22,-73 58,-14 53,3 81,21 25,-34 14,-99 -132,-67 l -11,-58 c 53,-16 145,-33 206,-6 55,25 75,122 25,166 -34,30 -144,62 -191,17 z m -6145,7671 c 103,98 525,-10 667,-37 219,-41 415,-98 637,-133 317,-51 329,-128 337,-71 29,194 54,385 105,573 21,79 76,226 85,294 0,-27 -6,-46 -11,-72 l -78,-524 c -35,-231 -50,-388 -71,-619 -19,-221 5,-446 12,-665 7,-216 40,-404 84,-595 86,-372 237,-679 407,-974 84,-145 175,-277 252,-439 80,-167 161,-292 173,-510 375,-104 579,-210 875,-387 287,-172 456,-338 680,-575 49,-53 93,-118 142,-181 234,-305 392,-663 565,-1004 46,-93 91,-200 155,-284 15,-19 68,-94 67,-110 -2,0 -5,-1 -6,-1 -28,1 -40,19 -57,40 -23,-12 -4,1 -22,-17 l -52,-45 c 21,-44 85,-184 135,-205 51,-22 671,-71 559,-248 -16,-27 -65,-47 -94,-66 65,-20 108,-22 108,-96 -28,-25 -52,-28 -78,-49 42,-27 103,-35 78,-124 -13,-42 -70,-70 -124,-85 150,-73 207,-110 316,-199 127,-104 186,-230 238,-273 60,124 336,143 356,-38 21,-185 -175,-263 -336,-184 -30,15 -26,22 -49,33 -18,8 -34,9 -54,17 l -441,293 c -252,168 -687,389 -873,589 -166,177 -146,520 -309,865 -99,210 -75,183 -211,381 -123,177 -269,315 -394,484 -42,57 -83,117 -125,171 -45,57 -221,250 -283,300 -47,38 -341,176 -396,196 -136,49 -393,42 -542,18 -114,-18 -325,-116 -421,-159 -67,-30 -433,-131 -463,-30 197,-7 255,42 386,116 117,67 222,118 348,172 133,56 290,61 454,64 161,4 293,-42 414,-105 98,-52 211,-158 272,-247 76,-110 161,-185 243,-277 86,-96 148,-190 232,-289 80,-94 168,-171 236,-274 59,-91 139,-164 218,-302 45,-79 127,-273 158,-362 194,-553 -12,-657 592,-967 289,-149 609,-366 872,-554 18,-13 42,-32 62,-31 67,1 -58,168 -77,195 -53,74 -81,99 -150,155 -56,47 -108,94 -173,131 -36,21 -184,78 -203,105 12,46 26,37 81,47 223,43 -5,139 -15,150 8,65 30,44 76,72 -44,32 -79,9 -116,63 -7,107 68,65 113,116 -23,55 -118,67 -181,89 -189,65 -349,20 -418,121 -21,30 -80,132 -91,168 -72,-15 -107,-61 -226,-44 -30,4 -35,8 -41,34 16,16 153,66 189,84 44,22 82,56 123,84 l 35,29 c -32,63 -79,118 -118,189 -36,65 -65,126 -100,195 -202,402 -433,861 -766,1171 -80,74 -148,146 -234,214 -222,175 -478,325 -743,441 l -327,122 c -53,17 -59,34 -98,7 -25,36 -14,27 -67,42 -79,22 -170,46 -234,80 83,10 215,-12 291,-22 -8,274 -400,843 -539,1118 -64,126 -130,234 -177,369 -106,304 -170,541 -209,893 -40,367 -28,699 -4,1064 -27,-1 -85,5 -110,16 l -684,158 c -205,47 -391,102 -596,131 -34,5 -74,9 -110,12 -18,1 -45,4 -63,-1 -24,-7 -14,-5 -18,-22 z"
            id="path2"
          />
          <path
            className="fil0"
            d="m 4610,13438 c -30,-100 -34,-211 -108,-199 -2,22 86,290 99,326 l 123,299 c -60,29 -88,124 -114,191 -103,272 -170,327 154,495 78,41 63,90 29,251 -27,-6 -31,-9 -61,2 l 8,31 c 6,30 -51,212 -61,249 -25,105 -35,197 -50,311 -27,202 -66,421 -83,630 -23,283 6,454 302,329 154,-65 320,-181 441,-275 73,-57 141,-104 207,-161 148,-130 435,-397 573,-503 l 773,-662 c -12,78 -64,212 -90,297 -232,749 -577,1128 -807,1891 -117,389 -211,874 -240,1307 -21,316 -42,764 20,1088 l 58,229 c 3,10 7,25 11,34 l 17,31 c -20,-245 -39,-487 -57,-734 -44,-580 132,-1507 295,-2030 94,-299 272,-667 417,-955 173,-345 283,-599 386,-976 l 55,-244 c 12,-56 32,-45 23,-70 -20,-49 0,-45 -19,-82 -23,10 -9,-12 -21,30 -3,10 -5,26 -7,40 -5,27 -8,48 -20,68 -30,46 -248,204 -296,241 l -196,163 c -67,62 -130,106 -193,166 -134,127 -258,217 -390,336 -131,118 -244,223 -381,336 -132,108 -267,202 -415,297 -51,33 -172,94 -244,111 -123,30 -142,-77 -143,-195 -1,-127 88,-786 119,-967 19,-107 40,-194 55,-305 97,-14 317,25 461,-85 -156,-25 -264,16 -415,27 90,-285 9,-249 -109,-329 -146,-99 -170,-86 -76,-326 23,-60 66,-192 102,-232 10,8 4,2 15,15 1,2 3,4 4,6 l 106,206 c -40,22 -98,60 -100,118 l 220,-140 c 60,-33 172,-105 257,-93 12,134 -256,233 -278,341 67,5 161,-93 224,-154 51,-49 154,-151 70,-247 -122,-19 -284,110 -366,151 -7,-10 -2,-1 -10,-20 l -188,-420 c -32,-81 -60,-154 -86,-239 z"
            id="path3"
          />
          <path
            className="fil0"
            d="m 7930,10318 c -33,12 33,-19 -12,9 -39,23 -29,3 -64,14 12,26 21,29 47,42 -2,123 -17,855 7,924 101,35 82,-85 85,-160 7,-153 -27,-644 -20,-730 233,27 255,35 507,33 182,-1 359,-5 538,-6 362,-2 723,-26 1075,-36 696,-20 1397,-62 2081,-115 337,-26 683,-33 1022,-67 465,-47 1621,-75 2115,-77 183,-1 365,-5 547,-7 122,-2 435,15 492,-62 -69,-46 -915,-20 -1057,-17 -743,17 -1382,35 -2124,83 -342,21 -692,51 -1031,67 -346,17 -690,63 -1031,72 -862,23 -2250,126 -3076,75 -67,-4 -73,1 -101,-42 z"
            id="path4"
          />
          <path
            className="fil0"
            d="m 16480,10014 c -60,-2 -68,-11 -69,47 -1,36 0,60 -3,93 -23,260 19,1052 24,1343 2,127 -6,279 2,401 6,91 7,278 0,362 -4,58 4,129 1,189 l -7,573 38,743 c 10,257 39,491 44,753 5,257 36,507 30,771 -3,125 3,254 1,376 -1,70 -17,335 9,367 142,173 107,-593 109,-653 6,-257 -34,-1282 -61,-1540 -13,-125 -7,-258 -17,-383 l -22,-372 c -2,-266 6,-523 8,-789 3,-258 -12,-518 -6,-771 3,-127 -39,-1374 -81,-1510 z"
            id="path5"
          />
          <path
            className="fil0"
            d="m 8451,16217 c 7,13 -1,20 53,28 18,3 34,4 55,6 259,25 616,-11 889,-9 344,3 692,-10 1031,-15 339,-6 692,-32 1031,-23 342,9 697,2 1040,-3 681,-10 1366,9 2049,-20 342,-15 679,-18 1017,-29 187,-7 696,20 762,14 99,-9 142,-8 141,-113 -34,-7 -168,17 -240,14 -229,-10 -533,-21 -754,-11 -161,7 -339,16 -501,17 -159,0 -352,4 -506,15 -164,12 -344,5 -507,12 -166,8 -340,10 -511,13 -172,3 -346,-7 -520,-4 -169,2 -332,5 -502,10 -340,8 -691,11 -1031,14 -336,3 -669,23 -1004,26 -334,4 -676,5 -1004,20 z"
            id="path6"
          />
          <path
            className="fil0"
            d="m 12843,14588 c 150,11 973,-20 1177,-29 118,-5 249,-32 353,-35 5,109 -36,299 4,387 -54,4 -129,-15 -184,-23 -51,-8 -120,-14 -174,-22 -206,-28 -1002,-6 -1176,21 z m 1594,-70 c 30,-22 22,1 38,-27 -26,-17 -11,1 -37,-14 -9,-5 -17,-14 -23,-20 -38,24 9,17 -45,29 -45,10 -400,2 -448,1 -346,-9 -661,27 -996,47 -111,7 -135,-1 -146,116 -8,82 -10,165 17,236 -2,1 -5,3 -7,4 l -12,8 c -34,19 -27,6 -46,31 136,88 1469,50 1665,-8 56,-104 45,-271 40,-403 z"
            id="path7"
          />
          <path
            className="fil0"
            d="m 12775,12824 c 12,46 21,2 24,80 l 13,204 c 13,90 -9,34 -14,92 15,12 0,8 33,17 64,17 659,-15 718,-19 190,-11 377,-6 571,-19 l 143,-10 c 11,-1 13,-1 25,-4 29,-9 8,-1 20,-10 -332,-98 -902,-30 -1274,-17 -71,2 -115,12 -183,19 l -14,-302 c 247,6 506,-25 762,-29 128,-2 258,-4 386,-12 127,-8 244,-35 363,-48 -3,116 -6,338 67,387 46,-61 19,-315 5,-361 -18,-58 -27,-58 -73,-47 -99,24 -416,-13 -542,-13 -179,0 -950,7 -1030,92 z"
            id="path8"
          />
          <path
            className="fil0"
            d="m 14338,14027 c -196,-4 -396,-49 -658,-44 l -260,11 c -201,-1 -386,44 -576,57 l -11,-335 c 155,3 490,-35 721,-38 157,-2 601,-4 715,-46 -129,-7 -254,-5 -383,-14 -355,-24 -658,-15 -1007,43 l -60,15 c -69,37 -20,311 -16,387 l -50,10 c 12,15 5,14 39,27 3,1 39,10 40,10 21,4 55,3 85,5 152,10 440,-21 628,-22 221,-1 605,-25 833,-54 -40,-26 -10,-95 -8,-211 1,-68 8,-188 0,-249 -101,27 -46,371 -32,448 z"
            id="path9"
          />
          <path
            className="fil0"
            d="m 5172,12848 c 43,172 330,925 424,1165 43,109 95,318 177,353 48,-150 -518,-1572 -592,-1615 -72,-42 -647,308 -692,404 -74,158 275,-101 310,-122 56,-34 120,-70 179,-98 z"
            id="path10"
          />
          <path
            className="fil0"
            d="m 8811,12629 c -10,-135 79,-308 142,-417 31,6 50,14 71,25 v 100 c -56,-1 -69,-36 -124,-9 13,28 8,21 49,36 21,8 41,15 58,22 -11,58 -106,234 -196,243 z m 243,-210 c 51,24 141,95 90,181 -32,54 -166,45 -204,109 -32,53 22,153 -6,176 -38,19 -114,5 -149,-8 -67,-26 -70,-35 -126,-2 -9,66 13,127 37,172 42,80 63,49 125,90 -72,57 -94,159 -143,243 -31,53 -53,66 -135,64 -64,-2 -120,-51 -155,-11 13,26 -32,4 74,35 245,72 264,-73 326,-220 17,-40 67,-126 90,-132 -10,-5 -15,-7 -28,-15 -20,-14 -2,-5 -26,-20 -52,-31 -103,-51 -107,-170 90,19 171,45 277,14 16,-63 -22,-145 -8,-205 71,-72 188,-13 220,-150 29,-124 -81,-160 -148,-216 6,-32 14,-73 0,-108 -8,-18 -13,-23 -31,-31 -13,-6 -17,-5 -28,-9 -3,0 -5,-1 -7,-2 -3,-1 -5,-2 -7,-2 -2,-1 -5,-3 -7,-3 -2,-1 -5,-2 -7,-3 19,-26 31,-25 45,-52 -101,-3 -215,266 -244,397 -40,183 131,168 248,-64 z"
            id="path11"
          />
          <path
            className="fil0"
            d="m 12748,11013 c 20,44 27,-10 26,80 -1,61 -3,200 15,255 l 21,35 c 30,-52 22,-211 20,-272 l 2,-69 c 8,-28 -7,0 10,-18 20,-13 737,-46 829,-50 119,-4 465,-37 593,-60 60,-10 143,-11 156,-59 -62,-34 -330,5 -417,14 -147,16 -292,23 -439,32 -207,13 -441,17 -645,51 -82,14 -133,5 -171,61 z"
            id="path12"
          />
          <path
            className="fil0"
            d="m 12836,11348 c 64,34 968,2 1140,-12 66,-6 114,-7 178,-20 l 148,-56 c -261,-47 -132,-22 -371,-24 l -772,28 -259,36 c -48,10 -58,8 -64,48 z"
            id="path13"
          />
          <path
            className="fil0"
            d="m 9879,11570 c -48,-33 -45,-121 -163,-82 -69,24 -108,86 -160,107 -64,-22 -64,-97 -178,-71 -66,15 -127,68 -129,138 l 46,26 c 42,-22 41,-61 108,-69 53,22 93,108 184,88 36,-8 141,-87 169,-107 152,189 252,22 317,-18 31,-19 17,-6 52,2 91,23 54,-151 -56,-131 -91,17 -135,107 -190,117 z"
            id="path14"
          />
          <path
            className="fil0"
            d="m 12853,12411 c 25,15 147,3 181,2 198,-5 375,-20 583,-21 242,-2 522,-6 759,-39 -257,-44 -508,-60 -786,-54 -120,2 -592,25 -709,84 -37,19 -16,4 -28,28 z"
            id="path15"
          />
          <path
            className="fil0"
            d="m 12837,12000 c 16,109 -19,261 34,369 l 13,-83 c 5,-104 10,-155 3,-269 244,-5 493,-29 739,-32 204,-1 352,-4 549,-25 59,-6 133,-24 185,-27 -5,128 -35,258 8,364 18,-13 3,2 16,-14 2,-3 10,-18 12,-24 5,-18 4,-34 5,-53 4,-218 35,-279 -103,-279 -158,1 -341,4 -497,11 -284,13 -714,-6 -964,62 z"
            id="path16"
          />
          <path
            className="fil0"
            d="m 9939,11126 c -11,-51 -13,-59 -40,-87 -111,-16 -122,72 -189,90 l -19,-98 c -72,17 -71,152 -20,181 86,47 138,-46 187,-72 l 14,85 c 135,53 119,-20 213,-70 l 46,44 c 20,15 37,19 65,15 12,-63 -26,-202 -77,-208 -58,-7 -119,99 -180,120 z"
            id="path17"
          />
          <path
            className="fil0"
            d="m 8794,11297 c 58,-41 74,-112 152,-144 42,32 62,148 126,139 74,-31 53,-113 175,-130 21,42 66,113 130,109 34,-24 47,-62 70,-98 15,-25 58,-64 59,-101 -49,0 -109,61 -138,81 -35,-40 -55,-94 -139,-74 -66,16 -100,56 -146,82 -24,-34 -30,-72 -68,-91 -44,-22 -82,10 -108,29 -34,26 -153,124 -113,198 z"
            id="path18"
          />
          <path
            className="fil0"
            d="m 10569,11079 -11,-9 c -8,-7 -6,-4 -15,-13 -140,-138 -170,65 -156,81 24,15 17,18 46,0 13,-8 21,-22 38,-34 24,39 49,97 118,81 62,-14 100,-61 144,-80 42,-18 109,31 137,55 53,46 113,48 145,-13 -13,-28 -188,-128 -203,-135 -111,-48 -168,38 -243,67 z"
            id="path19"
          />
          <path
            className="fil0"
            d="m 15073,11031 c 28,46 104,33 184,32 79,-1 146,-6 224,-8 108,-2 286,-27 372,-78 -64,-34 -328,-28 -415,-23 -92,5 -338,-9 -365,77 z"
            id="path20"
          />
          <path
            className="fil0"
            d="m 5695,14397 c -104,-44 -454,105 -550,192 -14,13 -33,30 -34,48 -1,20 -5,6 5,15 15,14 442,-93 546,-191 23,-22 43,-38 33,-64 z"
            id="path21"
          />
          <path
            className="fil0"
            d="m 15077,12064 c 71,58 444,-2 551,-35 67,-20 127,-22 158,-32 2,0 4,-1 6,-2 l 13,-6 c -237,-41 -357,-52 -589,-11 -67,11 -131,20 -139,86 z"
            id="path22"
          />
          <path
            className="fil0"
            d="m 12149,14639 c 9,72 2,125 -51,153 -146,78 -211,-121 -84,-191 59,-33 142,15 92,37 z m 75,121 c 20,-79 -22,-109 -72,-167 -55,-64 -212,-54 -271,90 -83,205 296,269 343,77 z"
            id="path23"
          />
          <path
            className="fil0"
            d="m 12093,12895 c 177,-2 155,242 -12,182 -166,-59 -76,-235 38,-215 -8,25 -7,14 -26,33 z m -25,-56 c -221,74 -168,353 84,312 159,-26 193,-244 38,-284 -55,-14 -15,-2 -55,-24 -31,-17 -34,-14 -67,-4 z"
            id="path24"
          />
          <path
            className="fil0"
            d="m 15146,11294 c 54,14 288,2 359,-1 60,-2 267,-5 330,-38 -2,-2 -5,-7 -6,-5 -1,2 -5,-3 -6,-4 -2,-1 -18,-9 -20,-10 -196,-87 -629,-25 -657,58 z"
            id="path25"
          />
          <path
            className="fil0"
            d="m 10569,11488 c -39,-29 -72,-73 -145,-38 -47,23 -96,55 -98,117 57,-6 77,-36 131,-47 44,74 128,78 209,20 105,-75 91,55 226,-31 -11,-54 -83,-81 -153,-87 -91,-6 -105,51 -170,66 z"
            id="path26"
          />
          <path
            className="fil0"
            d="m 15672,12469 c -16,-1 -102,-25 -126,-34 -102,-39 -426,-14 -419,64 6,71 199,60 278,48 102,-14 161,-53 267,-78 z"
            id="path27"
          />
          <path
            className="fil0"
            d="m 15095,11722 c 353,57 616,-84 696,-77 -190,-14 -460,-66 -641,22 -35,16 -47,23 -55,55 z"
            id="path28"
          />
          <path
            className="fil0"
            d="m 12089,11974 c 29,-7 38,-15 79,13 2,1 4,2 6,4 12,8 12,8 22,13 23,13 36,14 38,49 3,62 -54,126 -100,139 -79,23 -152,-22 -157,-86 -6,-86 49,-114 112,-132 z m -37,-17 c -240,60 -152,353 97,294 81,-20 159,-89 142,-198 -11,-71 -151,-118 -239,-96 z"
            id="path29"
          />
          <path
            className="fil0"
            d="m 15182,14383 c 71,80 462,17 555,-13 -14,-15 0,-5 -19,-15 l -14,-6 c -63,-22 -190,-34 -258,-32 -78,2 -251,-6 -264,66 z"
            id="path30"
          />
          <path
            className="fil0"
            d="m 12056,13735 c 19,-5 53,10 54,10 l 16,4 c 22,5 49,7 57,44 14,59 -45,122 -78,136 -130,56 -194,-159 -49,-194 z m -38,-21 c -48,23 -58,16 -83,73 -59,136 98,265 214,205 109,-55 133,-248 2,-276 -39,-9 -100,-17 -133,-2 z"
            id="path31"
          />
          <path
            className="fil0"
            d="m 15138,14701 c 201,-47 426,26 654,-45 -158,-52 -351,-46 -525,-21 -28,4 -57,10 -82,17 -37,12 -41,11 -47,49 z"
            id="path32"
          />
          <path
            className="fil0"
            d="m 14424,11307 c 74,-72 92,-370 53,-426 -63,22 -72,125 -84,197 -11,71 -40,203 31,229 z"
            id="path33"
          />
          <path
            className="fil0"
            d="m 15187,14965 c 104,32 224,11 310,-28 -50,-35 -83,-62 -168,-58 -71,3 -133,21 -142,86 z"
            id="path34"
          />
          <path
            className="fil0"
            d="m 4857,13254 c 48,-2 94,-33 129,-52 36,-21 86,-59 94,-92 -56,-23 -116,8 -159,27 -62,28 -101,37 -64,117 z"
            id="path35"
          />
          <path
            className="fil0"
            d="m 8859,11578 -6,74 c 86,-1 40,-45 123,-35 43,6 94,11 126,27 l 9,-49 c -101,-47 -172,-62 -252,-17 z"
            id="path36"
          />
          <path
            className="fil0"
            d="m 5026,13688 c 90,29 286,-139 295,-169 -71,8 -167,67 -232,108 -57,36 -51,25 -63,61 z"
            id="path37"
          />
          <path
            className="fil0"
            d="m 5129,13846 c 27,42 68,26 113,6 48,-21 74,-37 93,-78 -82,-11 -178,25 -206,72 z"
            id="path38"
          />
          <path
            className="fil0"
            d="m 4907,13487 c 43,19 114,-31 142,-51 47,-33 86,-55 121,-89 -85,4 -236,85 -263,140 z"
            id="path39"
          />
          <path
            className="fil0"
            d="m 5099,14536 c 4,-55 -28,-145 -101,-154 0,36 20,64 36,95 18,34 27,54 65,59 z"
            id="path40"
          />
          <path
            className="fil0"
            d="m 4681,13305 c 48,16 63,-1 72,-45 l -74,-9 z"
            id="path41"
          />
          <path
            className="fil0"
            d="m 4773,13553 c 52,-6 54,-17 49,-75 -39,13 -44,24 -49,75 z"
            id="path42"
          />
          <path
            className="fil0"
            d="m 4986,13935 c 33,14 55,5 65,-27 -30,-29 -61,-18 -65,27 z"
            id="path43"
          />
        </g>
      </g>
    </svg>
  );
};
